import React from "react";
import { useTranslation } from "@/langs/useTranslation";
import { BreadCrumbs } from "@/components/device/BreadCrumbs";
import Creation from "./Creation";

const CreateTemplate = () => {
  const { t } = useTranslation();

  return (
    <>
      <BreadCrumbs noTranslate schedule pageName={t({ defaultMessage: "排程模板" })} />
      <Creation />
    </>
  );
};

export default CreateTemplate;
